<template>
  <li class="dropdown user user-menu">
    <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
      <!-- The user image in the navbar-->
      <img v-bind:src="getUserImageUrl" class="user-image">
      <!--      <img :src="user.avatar" class="user-image" alt="User Image">-->
      <!-- hidden-xs hides the username on small devices so only the image appears. -->
      <span class="hidden-xs" style="color: #3c8dbc">.</span>
    </a>
    <!-- Account Info and Menu -->
    <ul class="dropdown-menu">
      <li class="user-footer">
        <router-link to="/team">
          <span>Team</span>
        </router-link>
      </li>
      <!-- <li class="user-footer">
        <router-link to="/products">
          <span>Products</span>
        </router-link>
      </li> -->
      <li class="user-footer">
        <router-link to="/profile">
          <span>Profile</span>
        </router-link>
      </li>
      <li class="user-footer">
        <router-link to="/profile">
          <span>Contact Us</span>
        </router-link>
      </li>
      <li class="user-footer">
        <router-link to="/order-history">
          <span>Order History</span>
        </router-link>
      </li>
      <li class="user-footer">
        <router-link to="/requested-list">
          <span>Requested List</span>
        </router-link>
      </li>
      <li class="user-footer">
          <router-link @click.native="logOut" to="/">
            <span>Logout</span>
          </router-link>
      </li>
    </ul>
  </li>
</template>

<script>
  import Vue from 'vue'

  export default {
    name: 'UsersMenu',
    methods: {
      logOut() {
        Vue.auth.destroyToken()
      },
      getUserImageUrl() {
        return 'https://smartapprcp.s3.ap-southeast-1.amazonaws.com/rcp_other/profile/' + Vue.auth.getUserImg()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UsersMenu.vue?a5f81170